import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";
import { Trash2 } from "lucide-react";
import { useEffect, useState } from "react";


export function CheckboxForm() {
    const { isFormDisabled, form } = useFieldFormContext();
    console.log("renderer")
    console.log(form?.getValues('field_options'))
    const [options, setOptions] = useState<string[]>(form?.getValues('field_options') as string[] || []);
    const [option, setOption] = useState<string>("");
    function onSubmit(e: React.FormEvent<HTMLButtonElement>) {
        e.preventDefault();
        setOption("");
        setOptions([...options, option]);
        form?.setValue('field_options', [...(options ?? []), option]);
    }
    useEffect(() => {
        setOption("");
    }, [])

    return (
        <div className="flex flex-col gap-2">
            <div>
                <p className="mb-2 text-sm font-medium">Add Option</p>
                <div className="flex gap-2">
                    <Input
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOption(e.target.value)}
                        type='text'
                        value={option}
                        disabled={isFormDisabled}
                        autoComplete="off"
                    />
                    <Button type="button" onClick={onSubmit} disabled={isFormDisabled || !option || options.includes(option)}>Add</Button>

                </div>
                {options.includes(option) && (
                    <p className="text-red-500">Option already exists</p>
                )}
            </div>

            <p className="font-medium">Options</p>

            <div className="flex flex-col gap-1">
                {options?.map((option) => (
                    <div key={option} className="flex items-center justify-between p-2 border rounded-md">
                        <p>{option}</p>
                        <div className="">
                            {!isFormDisabled && (
                                <Button
                                    size='action'
                                    variant='destructive'
                                    onClick={() => {
                                        setOptions(options.filter(o => o !== option));
                                        form?.setValue('field_options', options.filter(o => o !== option))
                                    }}
                                >
                                    <Trash2
                                        size='16'
                                    />
                                </Button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}